import { useEffect } from 'react'

import { useHistory } from '@/hooks'

const MY_COURSES_PATH = '/my/courses'

/**
 * The learner course list used to live at /my/trainings. Bookmarks, open tabs and older mail still
 * point there, so the old address forwards instead of erroring. Replace, not push: the dead path
 * should not become a place the Back button can return to.
 */
const LegacyCoursesRedirect = (): JSX.Element => {
  const history = useHistory()

  useEffect(() => {
    history.replace(MY_COURSES_PATH)
  }, [history])

  return <></>
}

export default LegacyCoursesRedirect
